import React from 'react';
import { translate } from 'react-i18next';

class AccountHelpSupport extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={this.props.activeState}>
        <legend>
          <h1>{this.props.t('AccountHelpSupport.help_and_support')}</h1>
        </legend>

        <p>{this.props.t('AccountHelpSupport.submit_instructions')}:</p>

        <p>
          <a href={window.EmployeeWeb.ENVConfig.support_link} target="_blank">
            {window.EmployeeWeb.ENVConfig.support_link}
          </a>
        </p>
      </div>
    );
  }
}

export default translate()(AccountHelpSupport);
